// Pictures for the cakes the website sells (the names and descriptions are in
// translations/home: menu.items.<id>; prices come from the server).
import caramelCake from "assets/slider/caramelCake.jpg";
import plainCake from "assets/slider/plainCake.jpg";
import butterCaramelCake from "assets/slider/butterCaramelCake.jpeg";
import customCake from "assets/slider/customCake.jpeg";

export const SHOP_IMAGES = {
  caramelCake,
  plainCake,
  butterCaramelCake,
  customCake,
  // the Christmas cakes that have a photo
  "xmas-normal-caramel-mixed-nospice-nococoa": caramelCake,
  "xmas-normal-plain-none-nospice-nococoa": plainCake,
  "xmas-butter-caramel-mixed-nospice-nococoa": butterCaramelCake,
};

export const WHATSAPP_SHOP = "919031392958";

export const formatRupees = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

// A Christmas cake's name from its id (xmas-butter-caramel-kaju-spice-cocoa),
// in the visitor's language. t is the "shop" translator.
export const isChristmasCake = (itemId) => /^xmas-/.test(itemId || "");
export function christmasCakeName(itemId, t, options) {
  const [, kind, caramel, fruit, spice, cocoa] = itemId.split("-");
  const name = (key) => t(`buy.name.${key}`, options);
  const extras = [
    kind === "butter" && name("butter"),
    !["none", "mixed"].includes(fruit) &&
      (fruit.includes("+")
        ? fruit
            .split("+")
            .map((one) => t(`buy.filter.${one}`, options))
            .join(" + ")
        : name(fruit)),
    spice === "spice" && name("spice"),
    cocoa === "cocoa" && name("cocoa"),
  ].filter(Boolean);
  const main = name(
    `${fruit === "none" ? "plain" : "fruit"}${caramel === "caramel" ? "Caramel" : ""}`,
  );
  return extras.length ? `${main} - ${extras.join(", ")}` : main;
}
